import { Table } from 'antd-v4'
import React from 'react'
import { ColumnKeys } from './enums'
import { IInventoryOnHand, TInventoryOnHandOptionalColumns } from './types'
import { calculateTotalFrom } from './utils'

const columnsToSum: Array<keyof IInventoryOnHand> = [
  ColumnKeys.TOTAL_COST,
  ColumnKeys.TOTAL_PRICE,
  ColumnKeys.QUANTITY,
]
export const TotalsSummaryRow = (
  inventoryOnHand: IInventoryOnHand[],
  columnDataKeys: Array<keyof IInventoryOnHand>,
  optionalColumns: TInventoryOnHandOptionalColumns,
) => {
  let visibleCellNumber = 0
  return (
    <Table.Summary.Row className='totals-row'>
      {columnDataKeys.map((dataKey, i) => {
        const isHiddenColumn = optionalColumns[dataKey] && !optionalColumns[dataKey]?.isShown
        if (isHiddenColumn) return
        const firstCellVal = visibleCellNumber === 0 && 'Totals'
        visibleCellNumber += 1
        const sumCellVal =
          columnsToSum.includes(dataKey) && calculateTotalFrom({ inventoryOnHand, key: dataKey })
        const classNames = `${sumCellVal ? 'text-right cell-pr' : ''} totals-cell`
        return (
          <Table.Summary.Cell index={i} key={i} className={classNames}>
            {firstCellVal || sumCellVal || ''}
          </Table.Summary.Cell>
        )
      })}
    </Table.Summary.Row>
  )
}
